import React from 'react';
import { shape, string } from 'prop-types';
import { Table } from '@devexpress/dx-react-grid-material-ui';

import RuleStatus from './RuleStatus';

const RuleStatusCell = ({ row, ...props }) => {
    let content = '';
    if (row.recalculationStatus === 'Running') {
        content = <RuleStatus rule={row} />;
    }
    return (
        <Table.Cell key={row.id} {...props}>
            { content }
        </Table.Cell>
    );
};

RuleStatusCell.defaultProps = {
    row: {}
};

RuleStatusCell.propTypes = {
    row: shape({
        recalculationStatus: string
    })
};

export default RuleStatusCell;
